import { Link } from 'react-router-dom'
import { Calendar, Phone } from 'lucide-react'
import { SITE } from '../content/siteContent'

interface CTASectionProps {
  headline?: string
  subheadline?: string
  tourLabel?: string
  callLabel?: string
}

export default function CTASection({
  headline    = 'Ready to Schedule a Tour?',
  subheadline = "We'd love to show you around and answer all your questions. Come see why families choose Grace Pointe.",
  tourLabel   = 'Schedule a Tour',
  callLabel   = 'Call Us Today',
}: CTASectionProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-brand-navy via-brand-blue to-brand-sky py-16 md:py-20">
      {/* Decorative shapes */}
      <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white/5 translate-x-1/2 -translate-y-1/2 blur-3xl" />
        <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-brand-amber/10 -translate-x-1/2 translate-y-1/2 blur-3xl" />
      </div>

      <div className="section-container relative z-10 text-center">
        <p className="text-brand-amber text-xs font-round font-bold tracking-[0.15em] uppercase mb-3">
          Open Enrollment
        </p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-bold text-white mb-4">{headline}</h2>
        <p className="text-slate-200 text-lg max-w-xl mx-auto mb-8 leading-relaxed">{subheadline}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/#contact" className="btn-gold px-8 py-4 text-base">
            <Calendar size={18} aria-hidden="true" />
            {tourLabel}
          </Link>
          <a
            href={`tel:${SITE.contact.phone.replace(/\D/g, '')}`}
            className="inline-flex items-center justify-center gap-2 bg-white/10 border-2 border-white/30 text-white font-semibold px-8 py-4 rounded-xl2 hover:bg-white/20 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-blue text-base"
          >
            <Phone size={18} aria-hidden="true" />
            {callLabel}
          </a>
        </div>

        {/* Hours note */}
        <p className="mt-6 text-slate-300 text-sm">
          {SITE.hours.days} · {SITE.hours.open} – {SITE.hours.close}
        </p>
      </div>
    </section>
  )
}
